import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './components/theme';

import { createBrowserHistory } from 'history';
import { SnackbarProvider } from 'notistack';
import indexRoutes from './routes/pages/default';
import { SebraeCookieConsent } from '@sebrae/cookie-consent';
import { AppContextProvider } from './components/shared/context';


const hist = createBrowserHistory();

function App() {
  return (
    <div style={{padding:0}}>
      <SebraeCookieConsent uuidApp="f335b43f-d864-4919-9a93-7508b9925530"/>
      <ThemeProvider theme={theme}>
        <AppContextProvider >
          <SnackbarProvider maxSnack={1}>
           
              <Router history={hist}>
                <Switch>
                  {indexRoutes.map((prop, key) => <Route path={prop.path} key={key} component={prop.component} />)}
                </Switch>
              </Router>
            
          </SnackbarProvider>
        </AppContextProvider>
      </ThemeProvider>
    </div>

  );
}

export default App;
